module.exports = __webpack_public_path__ + "img/lora+lato.edf32238.png";